import { supabase } from '../supabaseClient';

/**
 * Returns `count` available bots with ELO closest to `targetElo`.
 * All filtering (busy-check) and sorting happen inside the get_available_bots RPC.
 *
 * @param {number} targetElo  - average ELO of human players in the room
 * @param {number} count      - how many bots to fill
 * @returns {Promise<Array<{username: string, rating: number, bot_persona: string}>>}
 */
export const getAvailableBots = async (targetElo, count) => {
  const { data, error } = await supabase.rpc('get_available_bots', {
    p_target_elo: targetElo,
    p_count: count,
  });

  if (error) {
    console.warn('getAvailableBots error:', error.message);
    return [];
  }

  return data || [];
};

